import { useState, useCallback, useRef } from 'react';

export function useMeshSelection({ infoLookup, highlightMesh, resetHighlight }) {
  const [selectedPart, setSelectedPart] = useState(null);
  const [hotspotPosition, setHotspotPosition] = useState(null);
  const [screenSide, setScreenSide] = useState('right');
  const [hotspotKey, setHotspotKey] = useState(0);
  const selectionCountRef = useRef(0);

  const applySelection = useCallback((mesh, worldPos, normal, resolvedName) => {
    if (!worldPos) return;

    if (mesh && mesh.material) {
      resetHighlight();
      highlightMesh(mesh);
    }

    const meshName = resolvedName || mesh?.name || mesh?.material?.name || 'Unknown';
    const info = infoLookup(meshName, worldPos.x);

    setSelectedPart({
      meshName,
      english: info.english,
      latin: info.latin,
    });

    setHotspotPosition({
      position: `${worldPos.x.toFixed(4)}m ${worldPos.y.toFixed(4)}m ${worldPos.z.toFixed(4)}m`,
      normal: `${normal.x.toFixed(4)}m ${normal.y.toFixed(4)}m ${normal.z.toFixed(4)}m`,
    });

    setScreenSide(worldPos.x < 0 ? 'left' : 'right');

    selectionCountRef.current += 1;
    setHotspotKey(`${mesh?.uuid || meshName}-${selectionCountRef.current}`);
  }, [infoLookup, highlightMesh, resetHighlight]);

  const closeLabel = useCallback(() => {
    resetHighlight();
    setSelectedPart(null);
    setHotspotPosition(null);
  }, [resetHighlight]);

  return { selectedPart, hotspotPosition, screenSide, hotspotKey, applySelection, closeLabel, setScreenSide };
}
